module.exports = __webpack_public_path__ + "img/3-quad.59948ce0.png";